module.exports = __webpack_public_path__ + "img/cy.9296b2fd.svg";